// extracted by mini-css-extract-plugin
export var contentSection = "_a-8";
export var imageSection = "_a-1";
export var productGrid = "_a-0";
export var productImage = "_a-3";
export var productImageContainer = "_a-2";
export var productInfo = "_a-9";
export var purchaseControls = "_a-a";
export var quantityInput = "_a-c";
export var selectedThumbnail = "_a-6";
export var thumbnailContainer = "_a-4";
export var thumbnailImage = "_a-7";
export var thumbnailItem = "_a-5";
export var variantSelect = "_a-b";